import React from "react";
import { Box, Button, Dropdown, Tag } from "react-bulma-components";
import { Icon, IconText } from "../common/Icon";
import { UilEllipsisV, UilTrash, UilUserPlus } from "@iconscout/react-unicons";
import ProjectSection from "./ProjectSection";
import { MODAL_ADD_EXISTING_CONTACT, MODAL_ADD_NEW_CONTACT } from "./ProjectConstants";

export default function ProjectContacts({ contacts, onTriggerDelete, onTriggerModal, project }) {
    const actions = (
        <>
            <Button size="small" colorVariant="light"
                    onClick={ () => onTriggerModal(MODAL_ADD_EXISTING_CONTACT) }>
                <IconText icon={ UilUserPlus } size={ 12 }>
                    Add existing contact
                </IconText>
            </Button>

            <Button size="small" colorVariant="light"
                    onClick={ () => onTriggerModal(MODAL_ADD_NEW_CONTACT) }>
                <IconText icon={ UilUserPlus } size={ 12 }>
                    Add new contact
                </IconText>
            </Button>
        </>
    );

    const items = contacts.map(contact => {
        const onClickDropdownItem = async (value) => {
            if (value === 'delete') {
                await onTriggerDelete(`/api/projects/${ project }/contacts/${ contact.id }`);
            }
        }

        return (
            <Box key={ contact.contact.id } display="flex" p={ 4 } alignItems="flex-start">
                <div className="is-flex-grow-1">
                    <div>
                        <strong>{ contact.contact.name }</strong>
                    </div>
                    <div>
                        { contact.contact.phone_number }
                    </div>
                    <div>
                        { contact.contact.email_address }
                    </div>
                </div>

                <div className="is-size-7">
                    <Tag color="info" colorVariant="light">{ contact.association }</Tag>
                </div>

                <div className="ml-2 has-text-right">
                    <Dropdown hoverable right color="ghost" label={ <Icon icon={ UilEllipsisV }/> }
                              onChange={ onClickDropdownItem }>
                        {/* TODO: On click */ }
                        <Dropdown.Item renderAs="a" value="delete">
                            <IconText className="has-text-danger" icon={ UilTrash }>
                                Delete
                            </IconText>
                        </Dropdown.Item>
                    </Dropdown>
                </div>
            </Box>
        );
    });

    return (
        <ProjectSection title="Contacts" itemCount={ contacts.length } noItemsText="No contacts yet!"
                        actions={ actions }>
            { items }
        </ProjectSection>
    )
}